<template>
    <MainContent
        title="Editar pack de eventos"
    >
        <template v-slot:header>
            <h3>Datos del pack</h3>
        </template>
        <template v-slot:content>
            <Form
                v-if="pack"
                :data="pack"
                @terminado="editarPack()"
            />
        </template>
    </MainContent>
</template>

<script>
    import MainContent from '../../../components/backend/components/MainContent.vue'
    import Form from '@/components/backend/pack-eventos/Form.vue'

    export default {
        props: ['pack_id'],
        data() {
            return {
                pack: null
            }
        },
        created() {
            this.getPack();
        },
        methods: {
            editarPack() {
                this.$store.dispatch(this.config.getVuexAlias('back.teatro.packs-events.edit'), this.pack).then(res => {
                    this.$router.push({ name: 'back.packs-events.index' });
                });
            },
            getPack() {
                const params = {
                    filters : {},
                    pack_id: this.pack_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.packs-events.show'), params).then(res => {
                    this.pack = res.data.data;
                });
            }
        },
        components: {
            MainContent, Form
        }
    }
</script>